import { gql } from "@apollo/client";

const schema = {
  current: {
    name: "role",
    serviceName: "labadmin",
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
